import React from 'react';
import EmployeeLayout from './EmployeeLayout';
import { useAuth } from '../auth/AuthContext';

const Dashboard = () => {
  const { userName } = useAuth();

  const stats = [
    { title: 'Assigned Leads', value: '8', icon: '👥', color: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/20' },
    { title: "Today's Tasks", value: '3', icon: '📋', color: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20' },
    { title: 'Pending Visits', value: '2', icon: '📍', color: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border border-purple-500/20' },
    { title: 'Completed', value: '12', icon: '✅', color: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20' },
  ];

  const todayTasks = [
    { id: 1, customer: 'Rahul Sharma', task: 'Site Visit', time: '10:00 AM', status: 'Pending' },
    { id: 2, customer: 'Priya Patel', task: 'Call Follow-up', time: '2:00 PM', status: 'Pending' },
    { id: 3, customer: 'Amit Kumar', task: 'Quotation Send', time: '4:00 PM', status: 'Completed' },
  ];

  return (
    <EmployeeLayout>
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white">
          Welcome back, {userName || "Staff"}!
        </h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">Here is your daily summary and tasks</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white dark:bg-slate-900/50 rounded-2xl shadow-sm dark:shadow-xl p-6 border border-slate-200 dark:border-slate-800 transition-all hover:shadow-md">
            <div className="flex justify-between items-start">
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400">{stat.title}</p>
                <p className="text-2xl font-black text-slate-900 dark:text-white mt-1">{stat.value}</p>
              </div>
              <div className={`w-11 h-11 ${stat.color} rounded-xl flex items-center justify-center text-xl`}>
                {stat.icon}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white dark:bg-slate-900/50 rounded-2xl shadow-sm dark:shadow-xl border border-slate-200 dark:border-slate-800 overflow-hidden transition-colors">
        <div className="p-6 border-b border-slate-200 dark:border-slate-800/80">
          <h3 className="text-md font-bold text-slate-900 dark:text-white uppercase tracking-wider">Today's Tasks</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-slate-100/70 dark:bg-slate-950/80 text-slate-600 dark:text-slate-400 border-b border-slate-200 dark:border-slate-800">
              <tr>
                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Customer</th>
                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Task</th>
                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Time</th>
                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-800/60">
              {todayTasks.map((task) => (
                <tr key={task.id} className="hover:bg-slate-50 dark:hover:bg-slate-900/30 transition-colors">
                  <td className="px-6 py-4 text-sm font-bold text-slate-900 dark:text-white">{task.customer}</td>
                  <td className="px-6 py-4 text-sm text-slate-600 dark:text-slate-300 font-medium">{task.task}</td>
                  <td className="px-6 py-4 text-sm text-slate-500 dark:text-slate-400">{task.time}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-widest rounded-full ${
                      task.status === 'Completed' 
                        ? 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20' 
                        : 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400 border border-yellow-500/20'
                    }`}>
                      {task.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </EmployeeLayout>
  );
};

export default Dashboard;